<div class="table-wrapper">
  <!-- Header -->

  <!-- Loader -->
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select" *ngIf="enableSelection">
      <th
        mat-header-cell
        [ngClass]="{ isSticky: config.stickyHeader }"
        *matHeaderCellDef
      >
        <mat-checkbox (change)="selectAllRows($event.checked)"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (change)="onSelect(row, $event.checked)"
          [checked]="selected.includes(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Dynamic Columns -->
    <ng-container *ngFor="let col of columns" [matColumnDef]="col.key">
      <!-- Header -->
      <!-- <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header="{{ col.sortable ? '' : null }}"
      [ngClass]="{ isSticky: config.stickyHeader }"
    >
      {{ col.label }}
    </th> -->
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="{ isSticky: config.stickyHeader }"
      >
        {{ col.label }}
      </th>

      <!-- Cell -->
      <td mat-cell *matCellDef="let row" [ngClass]="col.cellClass">
        <div
          #cellEl
          class="tooltip-wrapper"
          [matTooltip]="getTooltip(cellEl)"
          [matTooltipDisabled]="!col.isToolTipEnable"
        >
          <!-- link -->
          <ng-container *ngIf="col.type === 'link'">
            <a
              class="link tableNameLink"
              [routerLink]="col.router"
              [queryParams]="{ id: row[col.queryParamId] }"
            >
              {{ row[col.key] }}
            </a>
          </ng-container>

          <!-- TEXT -->
          <ng-container *ngIf="col.type === 'text'">
            {{ row[col.key] ?? "-" }}
          </ng-container>

          <ng-container *ngIf="col.type === 'amount'">
            {{ row[col.key] ?? "-" | currency: "INR":"symbol":"1.2-2" }}
          </ng-container>

          <!-- NUMBER -->
          <ng-container *ngIf="col.type === 'number'">
            {{ row[col.key] ?? "-" }}
          </ng-container>

          <!-- DATE -->
          <ng-container *ngIf="col.type === 'date'">
            {{ row[col.key] ?? "-" | date }}
          </ng-container>

          <!-- CHIPS -->
          <!-- <mat-chip-set *ngIf="col.type === 'chip'">
          <mat-chip *ngFor="let chip of getChips(row, col)">{{
            chip
          }}</mat-chip>
        </mat-chip-set> -->

          <!-- JSON VIEW -->
          <!-- <div *ngIf="col.type === 'json'">
          <pre>{{ row[col.key] }}</pre>
        </div> -->

          <!-- HTML -->
          <div
            #cellElDiv
            class="tooltip-wrapper"
            [matTooltip]="getTooltip(cellElDiv)"
            *ngIf="col.type === 'html'"
            [innerHTML]="sanitize(row[col.key])"
            [matTooltipDisabled]="!col.isToolTipEnable"
          ></div>

          <!-- ACTIONS -->
          <div *ngIf="col.type === 'action'" class="action-icons">
            <button mat-icon-button (click)="col.render?.(row)">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="rowClick.emit(row)"
    ></tr>
  </table>

  <mat-paginator
    [length]="totalRecords"
    [pageSize]="config.defaultPageSize"
    [pageSizeOptions]="config.pageSizeOptions"
    (page)="onPageChange.emit($event)"
  >
  </mat-paginator>
</div>
